import styled from "styled-components"
import { lighten } from "polished"

const StyledFeature = styled.div`
  margin-bottom: 4rem;
  .text-image {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    align-items: center;
    :last-child {
      margin-bottom: 0;
    }
    video,
    img {
      max-width: 100%;
    }
    .content {
      order: 0;
      .title {
        padding: 0.5rem 0.75rem;
        border-radius: 10rem;
        background-color: ${({ theme }) => lighten(0.15, theme.colors.grey1)};
        font-size: 0.9rem;
        display: inline-block;
      }
      h4 {
        margin-bottom: 0.5rem;
      }
    }
    .media {
      order: 1;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.2);
      border-radius: 5px;
    }
  }
  .badges {
    margin-top: 2rem;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    .badge {
      display: flex;
      align-items: center;
      img,
      .icon {
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        min-width: 40px;
        max-width: 40px;
        height: 40px;
      }
      img {
        border-radius: 100%;
        margin-right: 1rem;
      }
      .icon {
        border-radius: 100%;
        margin-right: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          font-size: 1.25rem;
        }
        &.purple {
          background-color: #4d537d;
          color: #fff;
        }
        &.blue {
          background-color: #5164fd;
          color: #fff;
        }
        &.dark-blue {
          background-color: #28327d;
          color: #fff;
        }
      }
      span {
        display: block;
        font-size: 16px;
        color: #000;
        font-weight: 600;
      }
    }
  }

  @media only screen and (min-width: 400px) {
    .badges {
      grid-template-columns: 1fr 1fr;
    }
  }
  @media only screen and (min-width: 500px) {
    .badges {
      .badge {
        img,
        .icon {
          min-width: 70px;
          max-width: 70px;
          height: 70px;
          svg {
            font-size: 1.75rem;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 800px) {
    margin-bottom: 6rem;
    .text-image {
      grid-template-columns: 1fr 1fr;
      grid-gap: 4rem;
      .content {
        order: 0;
      }
      .media {
        order: 0;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .badges {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      .badge {
        justify-content: center;
      }
    }
  }
`

const Feature = StyledFeature

export default Feature
